import React, { useState } from 'react';
import { Tabs } from 'antd';
import LeadSatusesTable from './leadsStatusTable';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import LeadTable from '../leadsManagment';
import CreditManagement from '../creditManagement';

const LeadStatusTable: React.FC = () => {
    const [activeTab, setActiveTab] = useState('1');

  return (
    <div className="pt-6 bg-gray-100 rounded-lg w-full">
      <Tabs defaultActiveKey="1" onChange={key => setActiveTab(key)} tabBarStyle={{ borderBottom: '1px solid #d9d9d9' }} className="text-lg font-semibold tabs-custom-style">
        <Tabs.TabPane
          key="1"
          className="p-0"
          tab={
            <>
              <HeadingTypography
                classNames={`flex items-center h-[40px] px-[20px] ${
                  activeTab === '1' ? 'font-medium' : '!font-light text-gray-400 text-[#DBD7D7]'
                }`}
                fontSize={18}
              >
                Leads
              </HeadingTypography>
              {activeTab === '1' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#BD273B]" />}
            </>
          }
        >
          {activeTab === '1' && (
            <>
              <LeadSatusesTable />
              <LeadTable />
            </>
          )}
        </Tabs.TabPane>

        <Tabs.TabPane
          key="2"
          tab={
            <>
              <HeadingTypography
                fontSize={18}
                classNames={`flex items-center h-[40px] px-[20px] ${
                  activeTab === '2' ? 'font-medium' : '!font-light text-gray-400 text-[#DBD7D7]'
                }`}
              >
                Credit Risk
              </HeadingTypography>
              {activeTab === '2' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#BD273B]" />}
            </>
          }
        >
          {activeTab === '2' && <CreditManagement />}
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default LeadStatusTable;
